module.exports = __webpack_public_path__ + "img/relaxed.8d968416.svg";